import { render } from "./externaldataset-list.vue?vue&type=template&id=58cfbd03"
import script from "./externaldataset-list.vue?vue&type=script&lang=js"
export * from "./externaldataset-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__